import utils from "../common/util";
import * as flashScreen from "./cmp-flash-screen";

const cmpAdmin = {
    component: null,

    init: function (element)
    {
        utils.log('cmpCountdownTimer initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);
        _.resetDbBtns = document.getElementsByClassName('admin-btn');
        _.spinner = document.getElementById('splash-spinner');

        _.onClickEvent(_.resetDbBtns);
    },

    onClickEvent: function (elements)
    {
        const _ = this;
		console.log(elements);

        for (let element of elements) {
            element.addEventListener('click', () =>
            {
                // show the spinner
                utils.animateAndShow(_.spinner, 'opacity-0');

                // reset the db and go to the login page
                fetch(utils.getApiUrl() + '/admin-reset?', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + _.bearerToken
                    },
                })
                    .then(response => response.json())
                    .then(data =>
                    {
                        if(data.status === "Successful")
                        {
                            document.location.href = '/';
                        }
                    })
            })
        }
    }
}

export default cmpAdmin;
